import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneNumberUtil = PhoneNumberUtil.getInstance();
export interface CountryDropdwonOption {
  value: string;
  label: string;
}

const topListCountries = ['GB', 'IE', 'DE', 'US'];
const otherCountries = phoneNumberUtil
  .getSupportedRegions()
  .filter((regionCode: string) => !topListCountries.includes(regionCode));

export const countryDropdown: CountryDropdwonOption[] = topListCountries
  .concat(otherCountries)
  .map((regionCode: string) => mapSupportedRegions(regionCode));

function mapSupportedRegions(regionCode: string): CountryDropdwonOption {
  return {
    value: regionCode,
    label: `${regionCode} +${phoneNumberUtil.getCountryCodeForRegion(regionCode)}`,
  };
}
